<template>
    <div class="event-ticket--attributes">
        <section data-ticket-times>
            <div class="md-form" id="open_time_id-form">
                <i class="fa fa-clock-o prefix" :class="{'active':open_time_model!=''}"></i>
                <input type="text"
                       :id="open_time.id"
                       class="form-control timepicker"
                       v-model="open_time_model">
                <label :for="open_time.id" :class="{'active':open_time_model!=''}">open time</label>
            </div>
            <div class="md-form">
                <i class="fa fa-clock-o prefix" :class="{'active':close_time_model!=''}"></i>
                <input type="text"
                       :id="close_time.id"
                       class="form-control timepicker"
                       v-model="close_time_model">
                <label :for="close_time.id" :class="{'active':close_time_model!=''}">close time</label>
            </div>
        </section>
        <!--Spaces-->
        <section data-event-ticket-attrubutes--spaces class="container-fluid">
            <div class="row">
                <div class="col-6">
                    <div class="pseudo-form md-form">
                        <div class="pseudo-form--input border-0">
                            <!--seats switches-->
                            <div class="switch">
                                <label>
                                    Off
                                    <input type="checkbox"
                                           :checked="isTicketEventAttributeActive('seats','not grouped by entity / seats switches') === true ? 'checked' : null"
                                           @change="toggleTicketEventAttribute('seats')">
                                    <span class="lever"></span>
                                    On
                                </label>
                            </div>
                        </div>
                        <div class="pseudo-form--label active">
                            <i class="fa fa-cubes align-0"></i> Spaces
                        </div>
                    </div>
                </div>
                <div class="col-6 form-inline">
                    <div class="md-form mb-0 mb-md-4">
                        <input :id="'spaces-title-' + current_ticket.id"
                               class="form-control"
                               :disabled="isTicketEventAttributeActive( 'seats','not grouped by entity / seats input') !== true"
                               type="text"
                               :value="readAttributeTitle('seats')"
                        >
                        <label class="active"
                               :for="'spaces-title-' + current_ticket.id">
                            Spaces title
                        </label>
                    </div>
                    <div v-if="isTicketEventAttributeActive( 'seats','not grouped by entity / seats default')">
                        <div class="form-group ml-0 ml-md-3">
                            <input type="checkbox" class="filled-in"
                                   :id="'spaces-checked-' + current_ticket.id">
                            <label :for="'spaces-checked-' + current_ticket.id">Save
                                title as default</label>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Time Slots-->
        <section data-event-ticket-attrubutes--slots>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-6">
                        <div class="pseudo-form md-form">
                            <div class="pseudo-form--input border-0">
                                <!--time slot switches-->
                                <div class="switch">
                                    <label>
                                        Off
                                        <input type="checkbox"
                                               :checked="isTicketEventAttributeActive('slots','not grouped by entity / time slot switches') === true ? 'checked' : null"
                                               @change="toggleTicketEventAttribute('slots')">
                                        <span class="lever"></span>
                                        On
                                    </label>
                                </div>
                            </div>
                            <div class="pseudo-form--label active">
                                <i class="fa fa-clock-o align-0"></i> Time Slots
                            </div>
                        </div>
                    </div>
                    <div class="col-6 form-inline">
                        <div class="md-form mb-0 mb-md-4">
                            <input :value="readAttributeTitle('slots')"
                                   :disabled="isTicketEventAttributeActive( 'slots','not grouped by entity / slots inputs') !== true"
                                   type="text"
                                   :id="'slot-title-' + current_ticket.id"
                                   class="form-control" required>
                            <label class="active"
                                   :for="'slot-title-' + current_ticket.id">Time
                                slot
                                title</label>
                        </div>

                        <div v-if="isTicketEventAttributeActive('slots','not grouped by entity / slots inputs')"
                             class="form-group ml-0 ml-md-3">
                            <input type="checkbox"
                                   class="filled-in"
                                   :id="'slot-checked-' + current_ticket.id"
                                   checked="checked"
                            >
                            <label :for="'slot-checked-' + current_ticket.id">Save
                                title as default</label>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="accordionShowDown">
                <div data-show--slots="true"
                     v-if="isTicketEventAttributeActive( 'slots','not grouped by entity / slots list')"
                     class="pl-4 pr-4 p-2 mdb-color lighten-5">
                    <!--add new time slot-->
                    <div class="row" v-bind:key="index">
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="pseudo-form md-form">
                                <div class="pseudo-form--input"
                                     :class="{'pseudo-form--input-focus':time_slot_focused===true}">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div class="text-center pr-2">
                                            <!--v-model="time_slot.start"-->
                                            <input class="border-0 no-spinner"
                                                   type="time"
                                                   @focus="toggleTimeSlotFocus(true)"
                                                   @blur="toggleTimeSlotFocus(false)"
                                                   :ref="add_time_slot_ref"
                                                   v-model="add_time_slot.start"
                                            >
                                        </div>
                                        <div class="text-center pl-2 pr-2">
                                            -
                                        </div>
                                        <div class="text-center pl-2 pr-3">
                                            <!--v-model="time_slot.end"-->
                                            <input class="border-0 no-spinner"
                                                   type="time"
                                                   @focus="toggleTimeSlotFocus(true)"
                                                   @blur="toggleTimeSlotFocus(false)"
                                                   v-model="add_time_slot.end"
                                            >
                                        </div>
                                        <transition name="fade">
                                            <div v-if="(timeSlotActive())"
                                                 class="text-center">
                                                <div v-on:click="createTimeSlot()"
                                                     class="btn btn-sm btn-outline-danger m-0">
                                                    <i class="fa fa-check"></i>
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                                <div class="pseudo-form--label active"><i
                                        class="fa fa-clock-o"></i> New time slot
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4"
                             v-for="time_slot,index in readTimeSlots()">
                            <div class="d-flex align-items-center  justify-content-between watch-transition highlight-transition"
                                 :class="[{
                    'highlight-transition--danger':(time_slot.hasOwnProperty('error') && time_slot.error === true),
                    'highlight-transition--success':(time_slot.hasOwnProperty('success') && time_slot.success === true)

                    }]">
                                <div class="text-center pr-2">
                                    <!--v-model="time_slot.start"-->

                                    <input class="border-0" type="time"
                                           v-model="time_slot.start"
                                           v-on:blur="updateTimeSlot(ticketEventAttributeIndex( 'slots'))"
                                    >
                                </div>
                                <div class="text-center pl-2 pr-2">
                                    -
                                </div>
                                <div class="text-center pl-2 pr-3">
                                    <!--v-model="time_slot.end"-->

                                    <input class="border-0" type="time"
                                           v-model="time_slot.end"
                                           v-on:blur="updateTimeSlot(ticketEventAttributeIndex( 'slots'))"
                                    >
                                </div>
                                <div class="text-center">
                                    <div v-on:click="deleteTimeSlot(index)"
                                         href="#"
                                         class="btn btn-sm btn-outline-danger m-0">
                                        <i class="fa fa-trash"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </section>
    </div>
</template>

<script>
	import {_} from 'underscore';
	import {uniqueId} from '../../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';

	/**
	 *
	 * @uses http://weareoutman.github.io/clockpicker/
	 */
	export default {
		name:"event-ticket--attributes",
		props: [
			'current_ticket',
			'loading',
			'urls',
			'lang',
			'index',
			'add_time_slot',
			'methods_available',
		],
		created() {
		},
		destroyed() {
		},
		mounted() {
			let _this = this,
				open_time = this.readEventTicketAttribute('open_time'),
				close_time = this.readEventTicketAttribute('close_time'),
            openTimeElm = $('#' + _this.open_time.id),
            closeTimeElm = $('#' + _this.close_time.id);

			openTimeElm.val(open_time);
			_this.open_time_model = open_time;

			closeTimeElm.val(close_time);
			_this.close_time_model = close_time;

			_this.open_time.obj =openTimeElm.pickatime({
				twelvehour: false,
				default: open_time,
				afterDone: function (e) {
					_this.open_time_model = openTimeElm.val();

					// if the close time is less than the  open time, set close time to open time
					if (_this.close_time_model < _this.open_time_model) {
						_this.close_time_model = _this.open_time_model;
					}
				}
			});
			_this.close_time.obj = closeTimeElm.pickatime({
				twelvehour: false,
				default: close_time,
				afterDone: function (e) {
					_this.close_time_model = closeTimeElm.val();
					if (_this.close_time_model < _this.open_time_model) {
						_this.close_time_model = _this.open_time_model;
					}
				}
			});
		},
		data() {
			return {
				time_slot_focused: false,
				add_time_slot_ref: {},

				open_time_model: '',
				close_time_model: '',
				open_time: {
					id: uniqueId('open_time'),
					obj: '',
					data: '',
					elm: {
						cls: {
							icon: 'active'
						}
					}
				},
				close_time: {
					id: uniqueId('close_time'),
					obj: '',
					data: '',
					elm: {
						cls: {
							icon: 'active'
						}
					}
				}
			}
		},
		watch: {
			add_time_slot(val) {
				console.log('val', val);
			},
			open_time_model: function (value) {
				this.createOpenCloseTimes('open_time', value);
			},
			close_time_model: function (value) {
				this.createOpenCloseTimes('close_time', value);
			}
		},
		methods: {
			readEventTicketAttribute(attribute_key) {
				let data = ['ticket_data', 'entity_type_data', 'entity_type_fields', 'groups', 'open_close_full', 'items', attribute_key, 'value'];

				return this.methods_available.readEventTicketAttribute(this.current_ticket, 'open_close_full', [attribute_key, 'value'], data);
			},
			readAttributeTitle(slot) {

				let ticket_attribute = this.readAttributeRecord(slot);

				if (ticket_attribute !== null) {
					return ticket_attribute.ticket_event_attribute_data.lang[this.lang].title;
				}
			},
			readAttributeRecord(slot) {
				return _.findWhere(this.current_ticket.ticket_event_attributes, {type: slot}) || null;
			},
			createOpenCloseTimes(attribute_key, value) {


				// don't know why but this doesnt reach the parent of parent so im parsing to the event ticket edit mode vue
				this.$emit('event', {
					action: 'event_ticket_attributes__open_close_full',
					items: {
						value: {
							key: attribute_key,
							value: value
						}
					}
				});
				// console.log('after records', records);

			},
			/**
			 * Test if the attribute exists in the ticket and if it is active.
			 * Note: this function is used alot to test for whether it is active or not
			 * */
			isTicketEventAttributeActive(attribute_type, log) {
				let found = {
					result: false
				};

				this.current_ticket.ticket_event_attributes.some(function (attr) {
					if (attr.type === attribute_type && attr.status === 'active') {
						// console.log('found',attribute_type, attr.status);
						found['result'] = true;
						found['attr'] = attr;
						return found;
					}
					// console.log('attr',attr);
				});
				if (attribute_type == 'seats') {
					// console.log('log',log,found);
				}
				// console.log('found',found);
				return found.result;
			},
			/**
			 * toggles the ticket active or inactive
			 */
			toggleTicketEventAttribute(attribute_type) {
				if (this.loading) {
					return;
				}
// console.log('this.loading',this.loading);

				let _this = this,
					index_of_attribute = this.ticketEventAttributeIndex(attribute_type);

				if (index_of_attribute > -1) {
					let status = _this.current_ticket.ticket_event_attributes[index_of_attribute].status;

					// console.log('status', status);

					// _this.current_ticket.ticket_event_attributes[index_of_attribute].status = (status === 'active') ? 'inactive' : 'active';
					_this.$parent.$emit('event', {
						action: 'current_ticket_status',
						items: {
							index: index_of_attribute,
							value: (status === 'active') ? 'inactive' : 'active'
						}
					});
					// console.log('status', _this.current_ticket.ticket_event_attributes[index_of_attribute].status);

				}
				else {
					_this.$parent.$emit('event', {
						action: 'loading',
						items: {
							value: true
						}
					});
					axios(_this.urls.attributes_ticket_url + '?type=' + attribute_type)
						.then(function (response) {
							if (response.data.success) {
								// console.log('response.data.attribute', response.data.attribute);
								let data = {
									type: response.data.attribute.type,
									status: 'active',
									ticket_event_attribute_data: {
										lang: response.data.attribute.lang,
										value: response.data.attribute.value || null
									}
								};
								_this.$parent.$emit('event', {
									action: 'loading',
									items: {
										value: false
									}
								});
								_this.$parent.$emit('event', {
									action: 'event_ticket_attributes',
									items: {
										value: data
									}
								});
							}
						});
				}
			},

			ticketEventAttributeIndex(attribute_type) {
				let found = -1;

				this.current_ticket.ticket_event_attributes.forEach(function (attr, index) {

					if (found <= -1 && attr.type === attribute_type) {
						found = index;
					}
				});

				return found;
			},

			/**
			 * Toggles the state of the time slot focused
			 * @param isFocused
			 */
			toggleTimeSlotFocus(isFocused) {
				this.time_slot_focused = isFocused;
			},
			removeTimeSlotHighlightClass(timeSlot) {
				// console.log('timeSlot',timeSlot);
				if (timeSlot.hasOwnProperty('success')) {
					timeSlot.success = null;
				}
				if (timeSlot.hasOwnProperty('error')) {
					timeSlot.error = null;
				}
			},
			createTimeSlot() {
				let
					timeSlots = this.readTimeSlots(),
					previousIndex = null,
					cancelPutSlot = false,
					insert = {
						start: this.add_time_slot.start,
						end: this.add_time_slot.end,
						success: true,
						error: false
					};

				if (this.add_time_slot.start === this.add_time_slot.end) {
					console.log('clear slot');
					// clear slot
					this.deleteAddTimeSlotData();
					return;
				}
				else if (this.add_time_slot.start > this.add_time_slot.end) {
					console.log('inserting');
					insert = {
						start: this.add_time_slot.end,
						end: this.add_time_slot.start,
						success: true,
						error: false
					}
				}

				for (let index in timeSlots) {
					// console.log('slot', index);
					let slot = timeSlots[index];
					// console.log('slot', slot);
					// console.log('insert', insert);

					// no insert because they are the same
					if (insert.start === slot.start && insert.end === slot.end) {
						// throw error cannot insert the same slot again
						timeSlots[index].error = true;
						timeSlots[index].success = false;
						cancelPutSlot = true;
						break;
					}

					// insert is less than the slot
					if (insert.start < slot.start) {
						// console.log('prepend');
						// we have found a match of the previous record
						// insert the record after the previous record
						timeSlots.splice(index, 0, insert);
						cancelPutSlot = true;
						break;
					}
					// matched start times
					else if (insert.start === slot.start) {
						// console.log('start matched');
						// the start is the same but check the end
						if (insert.end < slot.end) {
							// console.log('end matched');
							// we have found a match of the previous record
							cancelPutSlot = true;
							// insert the record after the previous record
							timeSlots.splice(index, 0, insert);
							break;
						}
					}
					previousIndex = index;
				}

				if (!cancelPutSlot) {
					// console.log('inserting');
					timeSlots.push(insert);
				}
				// console.log( 'timeSlots', timeSlots, this.add_time_slot);

				// clear slot
				this.deleteAddTimeSlotData();
				this.updateTimeSlot(this.ticketEventAttributeIndex('slots'));
			},
			readTimeSlots() {
				let _this = this,
					ticket_attribute = this.readAttributeRecord('slots'),
					timeSlots = null;

				if (ticket_attribute !== null) {
					timeSlots = ticket_attribute.ticket_event_attribute_data.value;
				}

				timeSlots.forEach(function (timeSlot) {
					setTimeout(function () {
						_this.removeTimeSlotHighlightClass(timeSlot);
					}, 1500);
				});
				return timeSlots;
			},
			updateTimeSlot(ta_index) {
				let _this = this,
					ticket_attribute = this.readAttributeRecord('slots'),
					timeSlots = null,
					previous = null;

				if (ticket_attribute !== null) {
					timeSlots = ticket_attribute.ticket_event_attribute_data.value;
				}

				timeSlots.forEach(function (slot, index) {
					/**
					 * is the previous end value greater than the current start value?
					 */
					if (previous !== null && previous > slot.start) {
						slot.start = previous;
						timeSlots[index].start = previous;
					}

					if (slot.start > slot.end) {
						timeSlots[index].start = timeSlots[index].end;
						timeSlots[index]['errors'] = 'match'
					}
					// console.log('slot',slot,previous , current,calc);
					previous = slot.end;
					// console.log('timeSlots[index]',timeSlots[index]);
				});
				this.$nextTick(() => {
					// console.log('this.$refs[this.add_time_slot_ref]',this.$refs[this.add_time_slot_ref][0].$el);
					// focus on the first element
					console.error('this.$refs not working', this.$refs, this.add_time_slot_ref);
					// this.$refs[this.add_time_slot_ref][0].focus();
				});
			},
			/**
			 * Removes the timeslot from current_ticket
			 * @param index
			 */
			deleteTimeSlot(index) {
				let ticketSlots = this.current_ticket.ticket_event_attributes[this.ticketEventAttributeIndex('slots')].ticket_event_attribute_data.value;

				Vue.delete(ticketSlots, index);
			},
			deleteAddTimeSlotData() {
				this.$parent.$emit('event', {
					action: 'clear_time_slots'
				});
			},
			timeSlotActive() {
				return (this.add_time_slot.start !== '' && this.add_time_slot.end !== '') || false;
			}
		},

		computed: {}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTicketAttributes.vue?56e1aa3c